// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    padding-bottom: 10px;
    font-size: large;
    grid-row: 1;
}

.text {
    padding-bottom: 15px;
    max-height: 200px;
    grid-row: 2;
}

.group {
    background-color: aliceblue;
    padding: 15px;
    display: grid;
    grid: auto-flow / 1fr;
    grid-gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/logsettings/logsdialog.component.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,aAAa;AACjB","sourcesContent":[".header {\n    padding-bottom: 10px;\n    font-size: large;\n    grid-row: 1;\n}\n\n.text {\n    padding-bottom: 15px;\n    max-height: 200px;\n    grid-row: 2;\n}\n\n.group {\n    background-color: aliceblue;\n    padding: 15px;\n    display: grid;\n    grid: auto-flow / 1fr;\n    grid-gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
